module.exports = __webpack_public_path__ + "static/media/Default.b9c33df5.svg";